import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=296e1f9e&scoped=true"
import script from "./ziliao.vue?vue&type=script&lang=js"
export * from "./ziliao.vue?vue&type=script&lang=js"
import style0 from "./ziliao.vue?vue&type=style&index=0&id=296e1f9e&prod&lang=css"
import style1 from "./ziliao.vue?vue&type=style&index=1&id=296e1f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e1f9e",
  null
  
)

export default component.exports